import * as ActionType from '../../core/ActionType';
import * as Constants from '../../utils/constants';
import { ApiCallBeginAction } from '../api/Action';
import { setErrorResponse, setSuccessResponse } from '../responses/Action';
import { AgricultorService } from './Service';


export const getAgricultoresResponse = agricultorObject => ({
    type: ActionType.GET_AGRICULTORES_RESPONSE,
    agricultorObject,
});

export const addAgricultorResponse = motoristaObject => ({
    type: ActionType.ADD_AGRICULTOR_RESPONSE,
    motoristaObject
});


export function desativarOrAtivarAgricultorByIdAction(id,ativar) {
    return async function (dispatch) {
        await dispatch(setErrorResponse(null));        
        try {
            await AgricultorService.desativarOrAtivarAgricultor(id,ativar)
        } catch (error) {
            dispatch(setErrorResponse(error));
        }
    };
}
export function getAgricultoresAction(todos) {
    return async function (dispatch) {

        try {
            await dispatch(setErrorResponse(null));
            dispatch(ApiCallBeginAction());
            let agricultorObject = await AgricultorService.getAgricultores(todos);
            dispatch(getAgricultoresResponse(agricultorObject));
            // return agricultorObject;
        } catch (error) {
            dispatch(setErrorResponse(error));
        }
    };
}

export function getAgricultorByIdAction(id) {
    return async function (dispatch) {
        await dispatch(setErrorResponse(null));
        dispatch(ApiCallBeginAction());
        try {
            let agricultorObject = await AgricultorService.getAgricultorById(id);
            dispatch(getAgricultoresResponse(agricultorObject));
        } catch (error) {
            dispatch(setErrorResponse(error));
        }
    };
}


export function saveAgricultorAction(motorista) {
    return async function (dispatch) {
        await dispatch(setSuccessResponse(null));
        await dispatch(setErrorResponse(null));
        await dispatch(ApiCallBeginAction());
        try {
            let motoristaObject;

            if (motorista.id) motoristaObject = await AgricultorService.putAgricultor(motorista);
            else motoristaObject = await AgricultorService.postAgricultor(motorista);
            await dispatch(setSuccessResponse(Constants.DESCRICAO_SUCCESS));
            await dispatch(addAgricultorResponse(motoristaObject));
            return motoristaObject;
        } catch (error) {
            dispatch(setErrorResponse(error));
            throw error;
        }


    }
}